var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12C4.22386 12 4 11.7761 4 11.5L4 0.5C4 0.223858 4.22386 -3.39262e-08 4.5 -2.18557e-08C4.77614 -9.78512e-09 5 0.223858 5 0.5L5 11.5C5 11.7761 4.77614 12 4.5 12Z",
    fill: "#232629"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#232629"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 7,
    height: 3,
    rx: 1,
    fill: "#232629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/AlignCenter.2010ae114b992886b3a11a3e27768ea7.svg";
export { ForwardRef as ReactComponent };